// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-containers-App-index--fallback--VTucH {
  height: 100vh;
}

.src-containers-App-index--root--ZG0NP {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}
`, "",{"version":3,"sources":["webpack://./src/containers/App/index.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB","sourcesContent":[".fallback {\n  height: 100vh;\n}\n\n.root {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fallback": `src-containers-App-index--fallback--VTucH`,
	"root": `src-containers-App-index--root--ZG0NP`
};
module.exports = ___CSS_LOADER_EXPORT___;
